<template>
	<Chart
		ref="ref__chart"
		:options="chartOptions"
		class="w-full"
	/>
</template>

<script>
import { Chart } from 'highcharts-vue'

export default {
	name: 'GraficoNivelPovoamentoEstrato',
	components: {
		Chart,
	},
	props: {
		data: { type: Array, required: true },
		categorias: { type: Array, required: true, default: () => [] },
		titleY: { type: String, required: true, default: () => 'Valores' },
	},
	computed: {
		chartOptions() {
			return {
				chart: {
					type: 'column',
				},
				title: {
					text: '',
				},
				xAxis: {
					categories: this.categorias,
				},
				yAxis: {
					min: 0,
					title: {
						text: this.titleY,
					},
					stackLabels: {
						enabled: true,
						style: {
							fontWeight: 'bold',
							color:
								// theme
								(Highcharts.defaultOptions.title.style &&
									Highcharts.defaultOptions.title.style.color) ||
								'gray',
						},
					},
				},

				plotOptions: {
					series: {
						stacking: 'normal',
					},
				},

				series: this.data,

				tooltip: {
					pointFormat: '{series.name}: <b>{point.y}</b> ({point.percentage:.1f}%)<br/>',
				},
			}
		},
	},
}
</script>

<style>
.highcharts-container {
	width: 100% !important;
	height: 100% !important;
}
</style>
